<template>
  <v-card ref="form" class="grey lighten-4 pa-2" id="print">
    <v-layout>
      <v-flex>
        <v-select
          outlined
          v-if="activityLog && activityLog.length > 0"
          :items="activityLog"
          :label="activityLog[0]"
          @change="selectedActivity"
        ></v-select>
        <v-card-title class="Form__Title">
          <v-layout center>
            <v-flex xs12 class="mb-6">
              <h2 id="print2">
                {{
                  formHold.formType[0].toUpperCase() +
                  formHold.formType.slice(1)
                }}
                Waste Service Request
              </h2>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-row class="Form__Info">
          <v-col cols="12" sm="6" md="6">
            <span>
              <b>Request ID:</b>
              {{ formHold.requestId }}
            </span>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <span class="pr-4">
              <b>Current Status:</b>
              {{ formHold.status }}
            </span>
          </v-col>
        </v-row>
        <v-card flat outlined class="pa-2 pl-3 mb-2">
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <b>Site:</b>
              {{ formHold.sites }}
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <b>Building:</b>
              {{ formHold.building }}
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6" md="6">
              <b>Floor:</b>
              {{ formHold.floor }}
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <b>Room Number:</b>
              {{ formHold.roomNum }}
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6" md="6">
              <b>Location Description:</b>
              {{ formHold.locDesc }}
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <b>Department Name:</b>
              {{
                formHold.formType === "regular"
                  ? formHold.deptLocation
                  : formHold.department
              }}
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6" md="6">
              <b>Asset Manager:</b>
              {{ formHold.asstManager }}
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <b>Budget Code/Invoice Details:</b>
              {{ formHold.budgetCode }}
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6" md="6">
              <b>Open Date:</b>
              {{
                formHold.openedDate && formHold.openedDate.seconds
                  ? parseDate(formHold.openedDate.seconds * 1000)
                  : formHold.requestId.slice(0, 4) +
                    "-" +
                    formHold.requestId.slice(4, 6) +
                    "-" +
                    formHold.requestId.slice(6, 8)
              }}
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <b>Close Date:</b>
              {{
                formHold.closedDate && formHold.closedDate.seconds
                  ? parseDate(formHold.closedDate.seconds * 1000)
                  : formHold.closedDate
                  ? formHold.closedDate
                  : ""
              }}
            </v-col>
          </v-row>
        </v-card>

        <v-card flat outlined class="pa-2 pl-3 mb-2">
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <b>Contact First Name:</b>
              {{ formHold.fName }}
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <b>Contact Last Name:</b>
              {{ formHold.lName }}
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6" md="6">
              <b>Contact Number:</b>
              {{ formHold.phone }}
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <b>Contact Email:</b>
              {{ formHold.email }}
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6" md="6">
              <b>Alternate Contact First Name:</b>
              {{ formHold.altFName }}
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <b>Alternate Contact Last Name:</b>
              {{ formHold.altlLName }}
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6" md="6">
              <b>Alternate Contact Phone:</b>
              {{ formHold.altPhone }}
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <b>Alternate Contact Email:</b>
              {{ formHold.altEmail }}
            </v-col>
          </v-row>
        </v-card>

        <v-card flat outlined class="pa-2 pl-3 mb-2">
          <v-row
            v-if="
              formHold.formType === 'regular' || formHold.formType === 'other'
            "
          >
            <v-col cols="12" sm="6" md="6">
              <b>Waste Types:</b>
              <p
                class="pl-3"
                v-for="(waste, index) in formHold.selected"
                :key="index"
              >
                Type # {{ index + 1 }}: {{ waste }}
              </p>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <p>
                <b>Request Details:</b>
                {{ formHold.requestDetails }}
              </p>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" sm="6" md="12">
              <b>Waste Details:</b>
              <v-row>
                <v-col cols="12" sm="6" md="4" v-if="formHold.confWasteConsole">
                  <b>Confidential Waste Console:</b>
                  <p>Qty: {{ formHold.consoleQty }}</p>
                  <p>List: {{ formHold.consoleList }}</p>
                </v-col>
                <v-col cols="12" sm="6" md="4" v-if="formHold.confWasteBin">
                  <b>Confidential Waste Bin:</b>
                  <p>Qty: {{ formHold.binQty }}</p>
                  <p>List: {{ formHold.binList }}</p>
                </v-col>
                <v-col cols="12" sm="6" md="4" v-if="formHold.confWasteBag">
                  <b>Confidential Waste Bag:</b>
                  <p>Qty: {{ formHold.bagQty }}</p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>

        <v-card
          v-if="formHold.formType === 'regular'"
          flat
          outlined
          class="pa-2 pl-3 mb-2"
        >
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <!-- Outdated, use picURL -->
              <div v-if="formHold.picURL">
                <p>
                  <b>Pictures:</b>
                </p>
                <p
                  class="pl-3"
                  v-for="(pic, index) in formHold.picURL"
                  :key="index"
                >
                  Picture # {{ index + 1 }}:
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    :href="pic.link"
                    >{{ pic.name }}</a
                  >
                </p>
              </div>
              <div v-else-if="formHold.picArray">
                <p>
                  <b>Pictures:</b>
                </p>
                <p
                  class="pl-3"
                  v-for="(pic, index) in formHold.picArray"
                  :key="index"
                >
                  Picture # {{ index + 1 }}:
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    :href="pic.link"
                    >{{ pic.name }}</a
                  >
                </p>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <p>
                <b>"Warp It" system?:</b>
                {{ formHold.warpIt }}
              </p>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <b>Confirmation:</b>
              {{ formHold.confirm }}
            </v-col>
          </v-row>
        </v-card>

        <v-card class="pa-2 pl-3 mb-2">
          <v-row>
            <v-col md="6">
              <p class="pl-3 pt-1">
                <b>Notes/Comments:</b>
              </p>
            </v-col>
            <v-col md="2" class="pt-0">
              <v-checkbox
                v-model="chargeable"
                label="Chargeable"
                @change="updateChargeable"
                :disabled="formHold.status === 'Closed'"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row class="mt-0 pt-0">
            <v-col cols="12" md="6">
              <v-textarea
                class="Form__TextArea"
                :solo="true"
                @input="updateClosingNotes($event)"
                auto-grow
                multi-line
                :value="closingNotes"
              ></v-textarea>
            </v-col>

            <v-file-input
              multiple
              show-size
              @change="updatePics"
              chips
              counter
              outlined
              ref="myFileInput"
              accept="image/*"
              label="File input"
            ></v-file-input>
          </v-row>

          <!-- PREVIOUS INFO FROM ACTIVITY -->
          <v-row>
            <v-col v-if="prevNotes.length">
              <p class="Form__p">Previous Notes: {{ prevNotes }}</p>
            </v-col>
            <v-col v-if="picArray.length">
              <div v-for="(pic, index) in picArray" :key="pic">
                <a target="_blank" rel="noopener noreferrer" :href="pic"
                  >Previous Picture {{ index + 1 }}</a
                >
              </div>
            </v-col>
          </v-row>

          <v-flex>
            <h2>Current User: {{ user }}</h2>
            <v-text-field
              class="mt-4"
              :value="formHold.approvedBy"
              @input="updateApprovedBy($event, 'person')"
              label="Approved By:"
            ></v-text-field>
            <v-text-field
              :value="formHold.approvedByTitle"
              @input="updateApprovedBy($event, 'title')"
              label="Approved By Title:"
            ></v-text-field>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
    <v-card-actions>
      <v-layout class="Form__Buttons">
        <v-flex
          v-if="
            formHold.status === 'Open' ||
            formHold.status === 'On Hold' ||
            formHold.status === 'Closed Not Completed'
          "
          xs12
          md2
        >
          <v-btn
            text
            dark
            class="Form__Button teal clear btnNoPrint"
            @click="changeStatus(formHold.id, 'Closed')"
            >Close</v-btn
          >
        </v-flex>
        <v-flex
          v-if="formHold.status === 'Open' || formHold.status === 'On Hold'"
          xs12
          md3
        >
          <v-btn
            text
            dark
            class="Form__Button Form__Button--width teal clear btnNoPrint"
            @click="changeStatus(formHold.id, 'Closed Not Completed')"
            >Close Not Completed</v-btn
          >
        </v-flex>
        <v-flex
          v-if="
            formHold.status === 'Closed' ||
            formHold.status === 'Closed Not Completed' ||
            formHold.status === 'On Hold'
          "
          xs12
          md4
        >
          <v-btn
            text
            dark
            class="Form__Button teal clear btnNoPrint"
            @click="changeStatus(formHold.id, 'Open')"
            >Re-Open</v-btn
          >
        </v-flex>
        <v-flex v-if="formHold.status === 'Open'" xs12 md3>
          <v-btn
            text
            dark
            class="Form__Button teal clear btnNoPrint"
            @click="changeStatus(formHold.id, 'On Hold')"
            >On Hold</v-btn
          >
        </v-flex>
        <v-flex xs12 md2>
          <v-btn text class="Form__Button teal btnNoPrint" dark @click="print()"
            >Print</v-btn
          >
        </v-flex>
        <v-flex xs12 md2>
          <v-btn
            text
            class="Form__Button teal btnNoPrint"
            dark
            @click="exitForm()"
            >Exit</v-btn
          >
        </v-flex>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "Form",
  props: [
    "formHold",
    "changeStatus",
    "closingNotes",
    "print",
    "exitForm",
    "user",
    "approvedBy",
    "approvedByTitle",
    "activityLog",
    "activityDetails",
    "chargeable",
    "parseDate",
  ],
  data() {
    return {
      prevNotes: "",
      picArray: [],
      prevApprovedBy: "",
      prevApprovedByTitle: "",
    };
  },
  methods: {
    updateApprovedBy(input, type) {
      this.$emit("input", input, type);
    },
    updateClosingNotes(input) {
      this.$emit("closing-notes", input);
    },
    updateChargeable() {
      this.$emit("change-chargeable");
    },
    updatePics(input) {
      this.$emit("add-pics", input);
    },
    selectedActivity(selected) {
      this.picArray = [];
      this.prevNotes = "";
      const filteredArr = this.activityDetails.filter(
        (activityDetail) => activityDetail.activity === selected
      );
      this.picArray = filteredArr[0].picArray ? filteredArr[0].picArray : [];
      this.prevNotes = filteredArr[0].notes;
    },
  },
  watch: {
    formHold: {
      handler() {
        let element = document.getElementById("print");
        element.scrollIntoView(true);
        this.$refs.myFileInput.reset();
      },
    },
  },
  created() {},
};
</script>

<style>
.Form__Title {
  padding: 2px;
}
.Form__Buttons {
  display: flex;
  flex-flow: column wrap;
}
.Form__Button {
  margin: 5px auto;
  width: 100%;
}
.Form__Info {
  padding-left: 12px;
}
.v-list-item__title {
  height: 50px;
}
@media only screen and (min-width: 600px) {
  .Form__Title {
    padding: 0px;
  }
  .Form__TextArea {
    padding-left: 12px;
    white-space: pre-wrap;
  }
  .Form__p {
    white-space: pre-line;
  }
  .Form__Button {
    margin: 2px auto;
    width: 70%;
  }
  .Form__Button--width {
    width: 85%;
  }
  .Form__Buttons {
    flex-flow: row nowrap;
  }
}
</style>
